export default "__VITE_ASSET__DD$mrbgk__"